// extracted by mini-css-extract-plugin
export var dividerLine = "_49-0";
export var errorBackground = "_49-1";